var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import produce from 'immer';
import cloneDeep from 'lodash/cloneDeep';
var emptyTemplateData = {
    templateId: '',
    datasetId: '',
    patchId: '',
    rowId: '',
    meta: [],
};
export var getInitialState = function () { return ({
    templates_loading: false,
    templates_error: false,
    pushTemplates: [],
    pushTemplatesAppId: '',
    pushTemplateToEdit: null,
    template_to_edit_loading: false,
    template_to_edit_error: false,
    create_loading: false,
    create_error: false,
    update_loading: false,
    update_error: false,
    delete_loading: false,
    delete_error: false,
    selectedPushTemplateData: emptyTemplateData,
    selected_template_loading: false,
    selected_template_error: false,
    chosenPushTemplateId: '',
    datasetRows: [],
    datasetRows_loading: false,
    datasetRows_error: false,
}); };
function pushTemplateStateReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'LOAD_PUSH_TEMPLATES_REQUEST':
                state.templates_loading = true;
                state.templates_error = false;
                break;
            case 'LOAD_PUSH_TEMPLATES_SUCCESS':
                state.templates_loading = false;
                state.templates_error = false;
                state.pushTemplatesAppId = action.appId || '';
                state.pushTemplates = action.pushTemplates || [];
                break;
            case 'LOAD_PUSH_TEMPLATES_FAILURE':
                state.templates_loading = false;
                state.templates_error = true;
                state.pushTemplates = [];
                break;
            case 'LOAD_SELECTED_PUSH_TEMPLATE_DATA_REQUEST':
                state.selected_template_loading = true;
                state.selected_template_error = false;
                break;
            case 'LOAD_SELECTED_PUSH_TEMPLATE_DATA_SUCCESS':
                state.selected_template_loading = false;
                state.selected_template_error = false;
                state.selectedPushTemplateData =
                    action.templateData || emptyTemplateData;
                break;
            case 'LOAD_SELECTED_PUSH_TEMPLATE_DATA_FAILURE':
                state.selected_template_loading = false;
                state.selected_template_error = true;
                state.selectedPushTemplateData = emptyTemplateData;
                break;
            case 'LOAD_TEMPLATE_TO_EDIT_REQUEST':
                state.template_to_edit_loading = true;
                state.template_to_edit_error = false;
                break;
            case 'LOAD_TEMPLATE_TO_EDIT_SUCCESS':
                state.template_to_edit_loading = false;
                state.template_to_edit_error = false;
                state.pushTemplateToEdit = action.template || null;
                break;
            case 'LOAD_TEMPLATE_TO_EDIT_FAILURE':
                state.template_to_edit_loading = false;
                state.template_to_edit_error = true;
                state.pushTemplateToEdit = null;
                break;
            case 'CREATE_PUSH_TEMPLATE_REQUEST':
                state.create_loading = true;
                state.create_error = false;
                break;
            case 'CREATE_PUSH_TEMPLATE_SUCCESS':
                state.create_loading = false;
                state.create_error = false;
                state.pushTemplates = __spreadArray(__spreadArray([], (state.pushTemplates || []), true), [action.template], false);
                break;
            case 'CREATE_PUSH_TEMPLATE_FAILURE':
                state.create_loading = false;
                state.create_error = true;
                break;
            case 'UPDATE_PUSH_TEMPLATE_REQUEST':
                state.update_loading = true;
                state.update_error = false;
                break;
            case 'UPDATE_PUSH_TEMPLATE_SUCCESS':
                state.update_loading = false;
                state.update_error = false;
                var index = state.pushTemplates.findIndex(function (item) { return item.id === action.template.id; });
                var newPushTemplates = cloneDeep(state.pushTemplates);
                newPushTemplates[index] = action.template;
                state.pushTemplates = newPushTemplates || [];
                break;
            case 'UPDATE_PUSH_TEMPLATE_FAILURE':
                state.update_loading = false;
                state.update_error = true;
                break;
            case 'DELETE_PUSH_TEMPLATE_REQUEST':
                state.delete_loading = true;
                state.delete_error = false;
                break;
            case 'DELETE_PUSH_TEMPLATE_SUCCESS':
                state.delete_loading = false;
                state.delete_error = false;
                state.pushTemplates = state.pushTemplates.filter(function (t) { return t.id !== action.templateId; });
                break;
            case 'DELETE_PUSH_TEMPLATE_FAILURE':
                state.delete_loading = false;
                state.delete_error = action.error;
                break;
            case 'SELECT_CHOSEN_PUSH_TEMPLATE_ID_SUCCESS':
                state.chosenPushTemplateId = action.pushTemplateId;
                break;
            case 'SELECT_PUSH_TEMPLATE_ID_SUCCESS':
                state.selectedPushTemplateData.templateId =
                    action.selectedPushTemplateId;
                break;
            case 'SELECT_PATCH_ID_SUCCESS':
                state.selectedPushTemplateData.patchId = action.selectedPatchId;
                break;
            case 'SELECT_ROW_ID_SUCCESS':
                state.selectedPushTemplateData.rowId = action.selectedRowId;
                break;
            case 'SELECT_DATASET_ID_SUCCESS':
                state.selectedPushTemplateData.datasetId = action.selectedDatasetId;
                break;
            case 'SELECT_MAPPED_ARRAY_SUCCESS':
                state.selectedPushTemplateData.meta = action.mappedArray;
                break;
            case 'GET_DATASET_ROWS_REQUEST':
                state.datasetRows_loading = true;
                state.datasetRows_error = false;
                break;
            case 'GET_DATASET_ROWS_SUCCESS':
                state.datasetRows = action.datasetRows;
                state.datasetRows_loading = false;
                state.datasetRows_error = false;
                break;
            case 'GET_DATASET_ROWS_FAILURE':
                state.datasetRows_loading = false;
                state.datasetRows_error = true;
                break;
            case 'GET_DATASET_ROWS_RESET':
                state.datasetRows = [];
                break;
            default:
                break;
        }
    });
}
export default pushTemplateStateReducer;
